import React, { FC } from "react";
import FeatherIcon from "feather-icons-react";

interface SelectableChipProps {
  label: string;
  onDelete: () => void;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  size?: "small" | "medium";
}

/**
 * similar toMuiChip but with extra event handling to prevent the Select from toggling on mousedown/touchstart
 */
const SelectableChip: FC<SelectableChipProps> = ({
  label,
  onDelete,
  backgroundColor,
  borderColor,
  textColor,
  size = "medium",
}) => {
  const handleDeleteClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    event.preventDefault();
    onDelete();
  };

  const handleDeleteMouseDown = (
    event: React.MouseEvent | React.TouchEvent,
  ): void => {
    event.stopPropagation();
    // prevent the Select from toggling on mousedown/touchstart
    // MUI Select opens menu on mousedown, so block it here

    event.preventDefault();
  };

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: backgroundColor,
        border: `1px solid ${borderColor}`,
        color: textColor,
        borderRadius: size === "small" ? "2px" : "6px",
        padding: size === "small" ? "2px 8px" : "4px 12px",
        fontSize: size === "small" ? "12px" : "14px",
        fontWeight: 500,
        lineHeight: 1,
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <span style={{ marginRight: "6px" }}>{label}</span>
      <div
        onMouseDown={handleDeleteMouseDown}
        onTouchStart={handleDeleteMouseDown}
        onClick={handleDeleteClick}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "16px",
          height: "16px",
          borderRadius: "10%",
          color: textColor,
          opacity: 0.7,
          marginLeft: "2px",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = "1";
          e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = "0.7";
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        <FeatherIcon icon="x" size={12} />
      </div>
    </div>
  );
};

export default SelectableChip;
